import React from 'react';
import { RenderWidgetImage } from './constants';

export const EmptyStateDashboard = ({ iconId, title, description }) => {
    return (
        <div className="main-dashboard-empty-state-wrapper">
            {iconId != null && RenderWidgetImage(iconId, 'empty')}

            {title && <h2 className="dashboard-empty-state-title">{title}</h2>}

            {description && <div className="dashboard-empty-state-description">{description}</div>}
        </div>
    );
};
